import React from 'react';
import { Form, Formik, Field } from 'formik';
import * as Yup from 'yup';
import { Button, FestivalHeader, FormRow } from '../controls';
import { useFestivalWorkspaceStore } from '@/stores/festival-workspace-store';
import { useSendPushNotificationMutation } from '@/queries/push/useSendPushNotificationMutation';

const PushNotificationSchema = Yup.object({
  text: Yup.string().required('Message is required'),
});

function PushNotificationsForm({ sendMutation }) {
  const handleSubmit = (values, { resetForm }) => {
    sendMutation.mutate(values, {
      onSuccess: () => {
        resetForm({ title: '', text: '' });
      },
    });
  };

  const defaultValues = {
    text: '',
  };

  return (
    <>
      <FestivalHeader title="Push Notification" />
      <Formik
        enableReinitialize
        initialValues={defaultValues}
        onSubmit={handleSubmit}
        validationSchema={PushNotificationSchema}
      >
        {() => (
          <Form>
            <FormRow label="Message" errorName="text">
              <Field component="textarea" name="text" placeholder="Message" />
            </FormRow>
            <Button style={{ float: 'right' }}>Send Notification</Button>
          </Form>
        )}
      </Formik>
    </>
  );
}

function PushNotificationsReady({ festivalId }) {
  const sendMutation = useSendPushNotificationMutation(festivalId);
  return <PushNotificationsForm sendMutation={sendMutation} />;
}

export default function PushNotifications() {
  const festival = useFestivalWorkspaceStore((s) => s.festival);
  const festivalId = festival?.festivalId;

  if (!festivalId) {
    return (
      <>
        <FestivalHeader title="Push Notification" />
        <p className="p-6 text-gray-600">Select a festival first.</p>
      </>
    );
  }

  return <PushNotificationsReady festivalId={festivalId} />;
}
